import React from 'react';
import { CalendarIcon } from '@heroicons/react/24/outline';

/**
 * A reusable academic term selector component.
 * 
 * @param {Array} terms - List of academic terms {id, name}
 * @param {string|number} selectedTerm - Currently selected term ID or 'all'
 * @param {Function} onTermChange - Callback when term selection changes
 * @param {boolean} isLoading - Loading state
 */
const TermSelector = ({ terms, selectedTerm, onTermChange, isLoading }) => {
    return (
        <div className="flex items-center gap-2 bg-white/50 backdrop-blur-sm border border-slate-200/60 p-1 px-2 rounded-xl shadow-sm">
            <div className="h-7 w-7 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center shrink-0">
                <CalendarIcon className="h-4 w-4" />
            </div>
            <div className="flex flex-col">
                <span className="text-[9px] uppercase tracking-widest text-slate-400 font-bold leading-none mb-0.5">Filter by Term</span>
                <select
                    value={selectedTerm || ''}
                    onChange={(e) => onTermChange(e.target.value)}
                    disabled={isLoading}
                    className="bg-transparent text-[#18216D] text-[11px] font-black rounded-lg focus:ring-0 border-none block p-0 outline-none cursor-pointer hover:text-indigo-600 transition-colors appearance-none pr-4"
                    style={{
                        backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
                        backgroundPosition: 'right -4px center',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '1.25em 1.25em',
                    }}
                >
                    <option value="all" className="font-bold">All Terms (Academic Year)</option>
                    {terms?.map((term) => (
                        <option key={term.id} value={term.id} className="font-bold">
                            {term.name} {term.is_current ? '(Current)' : ''}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default TermSelector;
